<template>

    <div>

      <div class="row">


        <div 
          class="col-5" style="padding-right:0">
          <label>
            {{ formInputParameter.form_label || formInputParameter.key }}
          </label>
        </div>
        
        <div 
          class="col">
        </div>


        <div 
          class="col-5" style="padding-right:0">
          <label>
            Total
          </label>
        </div>

      </div>

      <div class="row">

        <div 
          class="col-5" style="padding-right:0">
          <input 
            class="form-control" 
            ref="input" 
            v-on:input="onInputInputted" 
            v-on:change="onInputChanged" 
            v-model="formData[formInputParameter.key]"
            v-bind="formInputAttr()" />
        </div>
        
        <div 
          class="col" style="padding:0">
        <label class="form-control" style="text-align:center; border:0; "> x {{ this.formInputParameter.form_multiplier }} </label>
        </div>

        <div 
          class="col-5" style="padding-left:0">
          <input 
            class="form-control" 
            ref="input" 
            v-on:input="onInputInputted" 
            v-on:change="onInputChanged" 
            v-model="inputValue"
            disabled="disabled" />
        </div>

      </div>

    </div>

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "AppFormInputFees",
  props: ['formCanEdit', 'formIsAdd', 'formInputParameter', 'formData'],
  data () {
    return {
      inputError: null,
      inputValue: null,
    }
  },
  methods: {
    formInputAttr: function() {
      let commontAttr = this.formInputParameter.form_input_attr || {};
      let specialAttr = (this.formIsAdd ? this.formInputParameter.form_add_input_attr : this.formInputParameter.form_edit_input_attr) || {};
      let allAttr = Object.assign({}, commontAttr, specialAttr);

      if(!this.formCanEdit) {
        allAttr['disabled'] = 1;
      }

      return allAttr;
    },

    onInputInputted() {
      setTimeout(() => {
        this.updateTotal();
        this.$emit('input');
      }, 100)
    },
    onInputChanged() {
      this.$emit('change');
    },

    updateTotal() {
      let number = parseFloat(this.formData[this.formInputParameter.key]);
      if(number && !isNaN(number)) {
        this.inputValue = helper.formatMoney(number * this.formInputParameter.form_multiplier);
      } else {
        this.inputValue = 0;
      }
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/App/AppFormInputFees.vue